const getEnv = () => {
    return process.env.REACT_APP_ENV || 'dev';
};

const env = getEnv();

const urls = {
    dev: 'https://mailcheck-dev-bsavadc5hbhreyfw.switzerlandnorth-01.azurewebsites.net/api/validate/email/academic',
    int: 'https://mailcheck-int-bsavadc5hbhreyfw.switzerlandnorth-01.azurewebsites.net/api/validate/email/academic',
    prd: 'https://mailcheck-prd-g0fagfg8bbcrexdq.switzerlandnorth-01.azurewebsites.net/api/validate/email/academic',
};

const sellerIds = {
    dev: "38377",
    int: "38377",
    prd: "251597",
};

const hubspotApiUrls = {
    dev: 'https://hubspot-dev-cxembxa3beg5d9aj.switzerlandnorth-01.azurewebsites.net/api',
    int: 'https://hubspot-int-gqf7f9dnhke3g3f4.switzerlandnorth-01.azurewebsites.net/api',
    prd: 'https://hubspot-prd-hafghud5arcdbxa3.switzerlandnorth-01.azurewebsites.net/api',
};

// The middleware is the source of truth for what is sold: it syncs the catalogue to Paddle
// and publishes the active prices (SKU, Paddle price id, cycle, quantity ceiling, list
// amounts) on an anonymous, CORS-open endpoint. The shop renders from that — it holds no
// price id of its own. Override per deployment with REACT_APP_MIDDLEWARE_API_URL.
const middlewareApiUrls = {
    dev: 'https://middleware-api-dev.spherene.io',
    int: 'https://middleware-api-int.spherene.io',
    prd: 'https://middleware-api.spherene.io',
};
const middlewareApiUrl = (process.env.REACT_APP_MIDDLEWARE_API_URL || middlewareApiUrls[env] || middlewareApiUrls.dev).replace(/\/+$/, '');

const config = {
    academicEmailValidationUrl: urls[env] || urls.dev,
    hubspotApiUrl: hubspotApiUrls[env] || hubspotApiUrls.dev,
    middlewareApiUrl,
    catalogueUrl: `${middlewareApiUrl}/api/v2.0/catalogue/public`,
    paddleEnv: env === 'prd' ? 'production' : 'sandbox',
    paddleApiKey: process.env.REACT_APP_PADDLE_API_KEY,
    paddleApiUrl: env === 'prd' ? 'https://api.paddle.com' : '/paddle-api', // Use local proxy for sandbox/dev
    paddleSellerId: sellerIds[env], // Optional fallback
};

export default config;
